import React from "react";
import { CircleHelp, Volume2 } from "lucide-react";

export default function HelpButton({ onClick, section, compact = false, className = "" }) {
  return (
    <button onClick={onClick} data-testid={`help-btn-${section}`} title="Narrated walkthrough of this section"
      className={`${compact ? "h-7 px-2 text-xs" : "h-9 px-3 text-sm"} rounded-full border border-amber-400/40 bg-amber-400/10 hover:bg-amber-400/20 text-amber-300 flex items-center gap-1.5 transition-colors ${className}`}>
      <CircleHelp className={compact ? "w-3.5 h-3.5" : "w-4 h-4"} />Help<Volume2 className="w-3 h-3 opacity-70" />
    </button>
  );
}
